import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable()
export class AuthErrorInterceptor implements HttpInterceptor {
  private isRedirectingToLogin = false;

  constructor(private readonly router: Router) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: unknown) => {
        if (
          error instanceof HttpErrorResponse &&
          [401, 403].includes(error.status)
        ) {
          this.navigateToLogin();
        }

        return throwError(() => error);
      }),
    );
  }

  private navigateToLogin(): void {
    if (this.isRedirectingToLogin || this.router.url === '/login') {
      return;
    }

    this.isRedirectingToLogin = true;
    this.router.navigate(['/login']).finally(() => {
      this.isRedirectingToLogin = false;
    });
  }
}
